// North-American phone formatting helpers. Strips non-digits, then formats
// progressively as the user types so partial entries still look right.

export function formatPhoneInput(raw: string): string {
  const digits = raw.replace(/\D/g, "").slice(0, 11);
  const trimmed = digits.startsWith("1") ? digits.slice(1) : digits;

  const area = trimmed.slice(0, 3);
  const exchange = trimmed.slice(3, 6);
  const line = trimmed.slice(6, 10);

  if (trimmed.length === 0) return "";
  if (trimmed.length <= 3) return `+1 (${area}`;
  if (trimmed.length <= 6) return `+1 (${area}) ${exchange}`;
  return `+1 (${area}) ${exchange}-${line}`;
}

export function phoneDigits(value: string): string {
  return value.replace(/\D/g, "");
}

// 10-digit "national" portion — strips the leading `1` country code if present
// so a fully-formatted "+1 (613) 555-1234" still reads as 10 digits for length
// checks, and submit can re-prefix without doubling the country code.
export function nationalPhoneDigits(value: string): string {
  const digits = phoneDigits(value);
  return digits.startsWith("1") ? digits.slice(1) : digits;
}
